var map = {
	"./key-horizontal-ghost.svg": 41,
	"./key-horizontal-unlocked.svg": 42,
	"./key-horizontal.svg": 43,
	"./key-rotated-unlocked.svg": 44,
	"./key-rotated.svg": 45,
	"./key-vertical-ghost.svg": 46,
	"./key-vertical-unlocked.svg": 47,
	"./key-vertical.svg": 48,
	"./maze-1.svg": 49,
	"./maze-2.svg": 50,
	"./maze-3.svg": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;